var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 2.375H13.0844L12.0195 0.778125C11.9625 0.692618 11.8852 0.622502 11.7946 0.573989C11.704 0.525475 11.6028 0.500062 11.5 0.5H6.5C6.39721 0.500062 6.29602 0.525475 6.2054 0.573989C6.11478 0.622502 6.03752 0.692618 5.98047 0.778125L4.91484 2.375H2.75C2.25272 2.375 1.77581 2.57254 1.42417 2.92417C1.07254 3.27581 0.875 3.75272 0.875 4.25V13C0.875 13.4973 1.07254 13.9742 1.42417 14.3258C1.77581 14.6775 2.25272 14.875 2.75 14.875H15.25C15.7473 14.875 16.2242 14.6775 16.5758 14.3258C16.9275 13.9742 17.125 13.4973 17.125 13V4.25C17.125 3.75272 16.9275 3.27581 16.5758 2.92417C16.2242 2.57254 15.7473 2.375 15.25 2.375ZM11.8125 8.3125C11.8125 8.86876 11.6475 9.41253 11.3385 9.87504C11.0295 10.3376 10.5902 10.698 10.0763 10.9109C9.56238 11.1238 8.99688 11.1795 8.45131 11.071C7.90574 10.9624 7.4046 10.6946 7.01126 10.3012C6.61793 9.9079 6.35006 9.40676 6.24154 8.86119C6.13302 8.31562 6.18872 7.75012 6.40159 7.2362C6.61446 6.72229 6.97495 6.28303 7.43746 5.97399C7.89997 5.66495 8.44374 5.5 9 5.5C9.74592 5.5 10.4613 5.79632 10.9887 6.32376C11.5162 6.85121 11.8125 7.56658 11.8125 8.3125Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/Camera.91ae4c0947cc3fda886a729ce575418a.svg";
export { ForwardRef as ReactComponent };